<template>
  <div class="individual_finished info_block_holder">
    <div v-if="this.showPositions" class="info_block">
      <span class="info_block_text_small">position</span><br>
      <span class="info_block_text_finished">
        <span class="icon-finish finish_icon"></span>
        <span id="finalposition">{{parseInt(athlete.position)}}</span>
      </span>
    </div>
    <div class="info_block">
      <span class="info_block_text_small">time</span><br><span class="info_block_text_finished" id="finaltime">{{toHHMMSS(athlete.properties.duration)}}</span>
    </div>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      athlete: 'focusedAthlete',
      showPositions: 'raceShowPositions'
    })
  },
  methods: {
    toHHMMSS: function (secs) {
      var secNum = parseInt(secs, 10) // don't forget the second param
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)
      if ((minutes < 10)) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      if (hours < 10) {
        hours = '' + hours
      }
      var time
      if (hours === '0') {
        time = '0:' + minutes + ':' + seconds
      } else {
        time = hours + ':' + minutes + ':' + seconds
      }
      return time
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/athlete/athleteFinished.vue